import { __rest } from 'tslib';
import * as MessageFormat from 'messageformat';
import { InjectionToken, Inject, Injectable, Optional, NgModule } from '@angular/core';
import { DefaultTranspiler, getValue, isObject, setValue, TRANSLOCO_CONFIG, TRANSLOCO_TRANSPILER } from '@ngneat/transloco';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/messageformat.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const TRANSLOCO_MESSAGE_FORMAT_CONFIG = new InjectionToken('TRANSLOCO_MESSAGE_FORMAT_CONFIG');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/messageformat.transpiler.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?=} locales
 * @param {?=} messageConfig
 * @return {?}
 */
function mfFactory(locales, messageConfig) {
    //@ts-ignore
    return new MessageFormat(locales, messageConfig);
}
class MessageFormatTranspiler extends DefaultTranspiler {
    /**
     * @param {?} config
     * @param {?=} userConfig
     */
    constructor(config, userConfig) {
        super(userConfig);
        const _a = config || { locales: undefined }, { locales } = _a, messageConfig = __rest(_a, ["locales"]);
        this.messageConfig = messageConfig;
        this.messageFormat = mfFactory(locales, messageConfig);
    }
    /**
     * @param {?} value
     * @param {?=} params
     * @param {?=} translation
     * @return {?}
     */
    transpile(value, params = {}, translation) {
        if (!value) {
            return value;
        }
        if (isObject(value) && params) {
            Object.keys(params).forEach((/**
             * @param {?} p
             * @return {?}
             */
            p => {
                /** @type {?} */
                const v = getValue((/** @type {?} */ (value)), p);
                /** @type {?} */
                const getParams = getValue(params, p);
                /** @type {?} */
                const transpiled = super.transpile(v, getParams, translation);
                /** @type {?} */
                const message = this.messageFormat.compile(transpiled);
                value = setValue(value, p, message(params[p]));
            }));
        }
        else if (!Array.isArray(value)) {
            /** @type {?} */
            const transpiled = super.transpile(value, params, translation);
            /** @type {?} */
            const message = this.messageFormat.compile(transpiled);
            return message(params);
        }
        return value;
    }
    /**
     * @param {?} lang
     * @return {?}
     */
    onLangChanged(lang) {
        this.setLocale(lang);
    }
    /**
     * @param {?} locale
     * @return {?}
     */
    setLocale(locale) {
        this.messageFormat = mfFactory(locale, this.messageConfig);
    }
}
MessageFormatTranspiler.decorators = [
    { type: Injectable }
];
/** @nocollapse */
MessageFormatTranspiler.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [TRANSLOCO_MESSAGE_FORMAT_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [TRANSLOCO_CONFIG,] }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/messageformat.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TranslocoMessageFormatModule {
    constructor() { }
    /**
     * @param {?=} config
     * @return {?}
     */
    static init(config) {
        return {
            ngModule: TranslocoMessageFormatModule,
            providers: [
                { provide: TRANSLOCO_MESSAGE_FORMAT_CONFIG, useValue: config },
                {
                    provide: TRANSLOCO_TRANSPILER,
                    useClass: MessageFormatTranspiler
                }
            ]
        };
    }
}
TranslocoMessageFormatModule.decorators = [
    { type: NgModule }
];
/** @nocollapse */
TranslocoMessageFormatModule.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngneat-transloco-messageformat.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MessageFormatTranspiler, TRANSLOCO_MESSAGE_FORMAT_CONFIG, TranslocoMessageFormatModule };

//# sourceMappingURL=ngneat-transloco-messageformat.js.map